module.exports = __webpack_public_path__ + "img/product-recycle.580a7d2e.svg";